<model-page [model]="model" [form]="mainForm">
  <navigation-bar [model]="model" [current-index]="0"></navigation-bar>
  <form name="mainForm" #mainForm="ngForm" class="form-horizontal" novalidate mas-workinghours>
    <fieldset>
      <legend>Uw gegevens</legend>

      <form-input name="birthdate" [control]="birthdate" [help]="true">
        <span form-label>Uw geboortedatum</span>
        <input form-control 
          id="birthdate" 
          name="birthdate" 
          #birthdate="ngModel" 
          [(ngModel)]="model.birthdate" class="form-control"
          required 
          mas-date-nl 
          mas-datepicker-nl
          [mas-date-min-age]="18"  
        /> 
        <span form-help>
          U dient minimaal 18 jaar oud te zijn.
        </span>
      </form-input>

      <form-input name="occupation-new" [control]="occupation" [help]="true">
        <span form-label>Uw beroep</span>
        <ng-select 
          form-control id="occupation" name="occupation" #occupation="ngModel" 
          [items]="occupationItems"
          bindLabel="text" 
          bindValue="code" 
          placeholder="" 
          [(ngModel)]="model.occupation" 
          >
        </ng-select>        
        <span form-help>
          U kunt zoeken in de tabel door (een gedeelte van) de beroepsomschrijving in te vullen.
          Staat uw beroep er niet bij, kies dan een beroep dat het meest overeenkomt.
        </span>
      </form-input>

      <fieldset id="hours">
        <legend>Hoe zijn uw werkzaamheden verdeeld per week (in uren)</legend>
        <form-input name="hoursPerWeekAdministrativeWork" [control]="hoursPerWeekAdministrativeWork">
          <span form-label>Administratief</span>
          <input form-control type="text" id="hoursPerWeekAdministrativeWork" name="hoursPerWeekAdministrativeWork" #hoursPerWeekAdministrativeWork="ngModel" class="form-control" [(ngModel)]="model.hoursPerWeekAdministrativeWork"
                 required mas-number-nl="integer" maxlength="15" />
        </form-input>

        <form-input name="hoursPerWeekManagement" [control]="hoursPerWeekManagement">
          <span form-label>Toezichthouden en/of leidinggeven</span>
          <input form-control type="text" id="hoursPerWeekManagement" name="hoursPerWeekManagement" #hoursPerWeekManagement="ngModel" class="form-control" [(ngModel)]="model.hoursPerWeekManagement"
                 required mas-number-nl="integer" maxlength="15" />
        </form-input>

        <form-input name="hoursPerWeekCommercial" [control]="hoursPerWeekCommercial">
          <span form-label>Commercieel</span>
          <input form-control type="text" id="hoursPerWeekCommercial" name="hoursPerWeekCommercial" #hoursPerWeekCommercial="ngModel" class="form-control" [(ngModel)]="model.hoursPerWeekCommercial"
                 required mas-number-nl="integer" maxlength="15" />
        </form-input>

        <form-input name="hoursPerWeekManualLabour" [control]="hoursPerWeekManualLabour">
          <span form-label>Handenarbeid</span>
          <input form-control type="text" id="hoursPerWeekManualLabour" name="hoursPerWeekManualLabour" #hoursPerWeekManualLabour="ngModel" class="form-control" [(ngModel)]="model.hoursPerWeekManualLabour"
                 required mas-number-nl="integer" maxlength="15" />
        </form-input>

        <div class="form-group row" *ngIf="mainForm.errors?.['tooManyWorkingHours'] && (mainForm.touched || mainForm.dirty)">
          <div class="col-form-label col-sm-6 text-sm-right">
          </div>
          <div class="col-sm-6 showworkinghourserror">
            Het totaal van het aantal gewerkte uren mag niet meer dan 60 zijn
          </div>
        </div>
      </fieldset>

      <form-input name="kilometersPerYearTravel" [control]="kilometersPerYearTravel">
        <span form-label>Hoeveel kilometer rijdt u zakelijk per jaar?</span>
        <input form-control type="text" id="kilometersPerYearTravel" name="kilometersPerYearTravel" #kilometersPerYearTravel="ngModel" class="form-control" [(ngModel)]="model.kilometersPerYearTravel"
               required mas-number-nl="integer" maxlength="6" />
      </form-input>

      <form-input name="highestEducation" [control]="highestEducation">
        <span form-label>Wat is uw hoogst genoten opleiding?</span>
        <select form-control type="text" id="highestEducation" name="highestEducation" #highestEducation="ngModel" class="form-control" [(ngModel)]="model.highestEducation" required>
          <option value="Lower">Lager onderwijs</option>
          <option value="Middle">Middelbaar onderwijs</option>
          <option value="Higher">Hoger onderwijs</option>
          <option value="Scientific">Wetenschappelijk onderwijs</option>
        </select>
      </form-input>

      <form-input-currency name="yearlyIncome" [control]="yearlyIncome" [help] ="true">
        <span form-label>Wat is gemiddeld uw bruto jaarinkomen van de laatste 3 jaar?</span>
        <input form-control-currency type="text" id="yearlyIncome" name="yearlyIncome" #yearlyIncome="ngModel" class="form-control" [(ngModel)]="model.yearlyIncome"
               required mas-number-nl="noninteger" maxlength="9" (blur)="DoBlurYearlyIncome()" />
        <span form-help>
          Op basis van uw bruto jaarinkomen wordt het verzekerd bedrag initieel afgeleid (80% van uw bruto inkomen).
          U kunt deze berekende verzekerde bedragen later zelf aanpassen.
          Indien u deels in loondienst bent geweest en deels als ZZP'er heeft gewerkt, dan kunt u deze bedragen bij elkaar optellen en delen door 3.
        </span>
      </form-input-currency>

    </fieldset>

    <fieldset>
      <legend>Stel uw arbeidsongeschiktheidsverzekering samen</legend>

      <form-input-currency name="insuredAmount" [control]="insuredAmount" [help]="true">
        <span form-label>Welk bedrag wilt u verzekeren?</span>
        <input form-control-currency id="insuredAmount" name="insuredAmountName" #insuredAmount="ngModel" class="form-control" [(ngModel)]="model.insuredAmount"
          required mas-number-nl="noninteger" [mas-number-maxvalue]="0.8*model.yearlyIncome"/>
        <span form-help>
          Het is mogelijk om maximaal 80% van uw gemiddelde bruto-inkomen van de afgelopen 3 jaar te verzekeren uit loondienst. (zie uw jaaropgaven)
          of maximaal 80% van uw gemiddelde bruto-jaarwinst (zie uw winst - en verliesrekening) als ZZP'er over de afgelopen 3 jaar.
        </span>
      </form-input-currency>

      <form-input name="waitingDays" [control]="waitingDays">
        <span form-label>Welke periode wilt u overbruggen voordat uw verzekering uitkeert? </span>
        <select form-control id="waitingDays" name="waitingDays" #waitingDays="ngModel" class="form-control" [(ngModel)]="model.waitingDays"
                required>
          <option [ngValue]="14">14 dagen</option>
          <option [ngValue]="30">1 maand</option>
          <option [ngValue]="60">2 maanden</option>
          <option [ngValue]="90">3 maanden</option>
          <option [ngValue]="180">6 maanden</option>
          <option [ngValue]="365">1 jaar</option>
          <option [ngValue]="730">2 jaar</option>
          <option [ngValue]="1095">3 jaar</option>
        </select>
      </form-input>

      <form-input name="indexationOfInsuredAmount" [control]="indexationOfInsuredAmount">
        <span form-label>Wilt u het verzekerd bedrag jaarlijks verhogen?</span>
        <div form-control>
          <div class="form-check form-check-inline">
            <input [attr.disabled]="model.style === 'zzp' ? 'disabled' : null" id="indexationOfInsuredAmountYes" name="indexationOfInsuredAmount" type="radio" class="form-check-input" #indexationOfInsuredAmount="ngModel" [(ngModel)]="model.indexationOfInsuredAmount" [value]="true" required>
            <label for="indexationOfInsuredAmountYes" class="form-check-label">Ja</label>
          </div>
          <div class="form-check form-check-inline">
            <input [attr.disabled]="model.style === 'zzp' ? 'disabled' : null" id="indexationOfInsuredAmountNo" name="indexationOfInsuredAmount" type="radio" class="form-check-input" [(ngModel)]="model.indexationOfInsuredAmount" [value]="false" required>
            <label for="indexationOfInsuredAmountNo" class="form-check-label">Nee</label>
          </div>
        </div>
      </form-input>

      <form-input name="indexationOfBenefit" [control]="indexationOfBenefit">
        <span form-label>Wilt u uw uitkering (als u arbeidsongeschikt raakt) jaarlijks verhogen?</span>
        <div form-control>
          <div class="form-check form-check-inline">
            <input [attr.disabled]="model.style === 'zzp' ? 'disabled' : null" id="indexationOfBenefitYes" name="indexationOfBenefit" type="radio" class="form-check-input" #indexationOfBenefit="ngModel" [(ngModel)]="model.indexationOfBenefit" [value]="true" required>
            <label for="indexationOfBenefitYes" class="form-check-label">Ja</label>
          </div>
          <div class="form-check form-check-inline">
            <input [attr.disabled]="model.style === 'zzp' ? 'disabled' : null" id="indexationOfBenefitNo" name="indexationOfBenefit" type="radio" class="form-check-input" [(ngModel)]="model.indexationOfBenefit" (ngModelChange)="indexationOfBenefitChanged($event)" [value]="false" required>
            <label for="indexationOfBenefitNo" class="form-check-label">Nee</label>
          </div>
        </div>
      </form-input>

      <form-input name="benefitIndexationMethod" [control]="benefitIndexationMethod" *ngIf="model.indexationOfBenefit">
        <span form-label>Met welke percentage?</span>
        <select form-control id="benefitIndexationMethod" name="benefitIndexationMethod" #benefitIndexationMethod="ngModel" class="form-control" [(ngModel)]="model.benefitIndexationMethod"
                required [disabled]="model.style === 'zzp' ? 'disabled' : null">
          <option *ngIf="model.style !== 'zzp'" value="TwoPercent">2%</option>
          <option *ngIf="model.style !== 'zzp'" value="ThreePercent">3%</option>
          <option value="CBS">CBS-loonindexatie</option>
        </select>
      </form-input>

    </fieldset>

    <div class="form-group row">
      <div class="offset-md-6 col-sm-6 text-right">
        <button type="button" class="btn btn-primary" [attr.disabled]="mainForm.form.valid ? null : 'disabled'" (click)="onCalculate()">Bereken premie</button>
      </div>
    </div>

    <div *ngIf="top3 && top3.length" id="product-premiums">

      <div class="row">
        <div class="col-sm-12">
          <ul class="nav nav-tabs">
            <li class="nav-item"><a class="nav-link" [ngClass]="{'active': !ui.showAllProducts}" href="javascript:{}" (click)="ui.showAllProducts = false">Top 3</a></li>
            <li class="nav-item"><a class="nav-link" [ngClass]="{'active': ui.showAllProducts}" href="javascript:{}" (click)="ui.showAllProducts = true">Alle producten</a></li>
          </ul>
        </div>
      </div>

      <div class="row premium-top3" *ngIf="!ui.showAllProducts">
        <div class="col-sm-12 text-center">
          <div class="card-deck">
            <premium-card class="card" *ngFor="let product of top3" [product]="product"></premium-card>
          </div>
        </div>
      </div>

      <div class="row" *ngIf="ui.showAllProducts">
        <div class="col-sm-12">
          <table class="table table-bordered table-condensed text-center">
            <thead>
              <tr>
                <th>Maatschappij</th>
                <th>Product</th>
                <th>Eerstejaars premie</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let product of allProducts">
                <td><img src="assets/company-images/{{product.insuranceCompanyCode}}_large.jpg" style="width:150px;" /></td>
                <td>{{product.productName}}</td>
                <td>{{product.premium | currency:'EUR'}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <p>Bovenstaande berekening vormt een indicatie voor een arbeidsongeschiktheidsverzekering voor het eerste jaar, dit is inclusief een aanvangskorting. Let op: dit is nog geen offerte. Laat u voor een passend advies, afgestemd op uw persoonlijke situatie, adviseren door één van onze adviseurs. De daadwerkelijke tariefstelling en acceptatie zal plaatsvinden door de verzekeraar aan de hand van een volledig ingevuld en ondertekend aanvraagformulier inclusief een gezondheidsverklaring. Aan deze berekening kunnen geen rechten worden ontleend.</p>
    </div>

    <div class="row">
      <div class="col-sm-6 text-left">
        <!--<button type="button" class="btn btn-default" (click)="onPrevious()">Vorige</button>-->
      </div>
      <div class="col-sm-6 text-right">
        <button type="button" class="btn btn-primary" [attr.disabled]="mainForm.form.valid && top3 && top3.length ? null : 'disabled'" (click)="onNext()">Advies aanvragen</button>
      </div>
    </div>
  </form>
</model-page>
